export async function trackViewedReadMore() {
  const amplitude = (await import("trackers/amplitude")).default;
  amplitude.logEvent("viewed_READ_MORE");
}

export async function trackRegisteredEvent(registerableEvent) {
  const amplitude = (await import("trackers/amplitude")).default;
  amplitude.logEvent("registered_EVENT", { registerableEvent });
}

export async function trackSwitchedPriority(tag, email) {
  const amplitude = (await import("trackers/amplitude")).default;
  amplitude.logEvent("switchedpriority_APPLICATION", {
    tag,
    email,
  });
}

export async function setUserId(email) {
  const amplitude = (await import("trackers/amplitude")).default;
  amplitude.setUserId(email);
}

export async function trackRejectedSubmission({ name, size, type }) {
  const amplitude = (await import("trackers/amplitude")).default;
  amplitude.logEvent("rejected_SUBMISSION", { name, size, type });
}

export async function trackEditedProfile() {
  const amplitude = (await import("trackers/amplitude")).default;
  amplitude.logEvent("edited_PROFILE");
}

export async function trackUploadedSubmission(eventId) {
  const amplitude = (await import("trackers/amplitude")).default;
  amplitude.logEvent("uploaded_SUBMISSION", { eventId });
}

export async function logError(error, info) {
  const { withScope, captureException } = await import("trackers/sentry");
  withScope(scope => {
    Object.keys(info).forEach(key => {
      scope.setExtra(key, info[key]);
    });
    captureException(error);
  });
}
